var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`mc-badge ${_vm.computedVariant} ${_vm.computedSize} ${_vm.computedType}`,style:(_vm.computedStyle)},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }